export const EducationData = "EducationData/";
export const HonsAwardsData = "HonorsAwardsData/";
export const ProfessionalExpData = "ProfessionalExpData/";
export const PublicationsData = "PublicationsData/";

export const textColor = "#000";
